// src/components/termMatcher.js
//
// Pure (JSX-free) builder for the glossary/annotation matcher used by AnnotatedText.
// Kept separate so it is unit-testable under `node --test`. Returns { regex, byLower }
// or null when there are no usable terms.
//
// Term shape: { id, name, category, definition, example, tip, scope?, packIds? }.

const RX_ESCAPE = /[.*+?^${}()|[\]\\]/g;

// One case-insensitive, word-bounded matcher over all term names. Longer names sort
// first so multi-word phrases ("dramatic irony") win over substrings ("irony"). The
// caller orders pack annotations before globals so a pack term wins a name collision.
export function buildTermMatcher(terms) {
    const valid = (Array.isArray(terms) ? terms : []).filter((t) => t && typeof t.name === 'string' && t.name.trim());
    if (!valid.length) return null;
    const byLower = new Map();
    for (const t of valid) {
        const k = t.name.trim().toLowerCase();
        if (!byLower.has(k)) byLower.set(k, t); // first wins
    }
    const names = [...byLower.keys()].sort((a, b) => b.length - a.length);
    const alt = names.map((n) => n.replace(RX_ESCAPE, '\\$&')).join('|');
    try {
        return { regex: new RegExp('\\b(' + alt + ')\\b', 'gi'), byLower };
    } catch {
        return null;
    }
}
